exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".column-wrapper {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    padding-bottom: 30px;\n}\n\n.column--1-2 {\n    padding: 0 14px 20px 20px;\n    width: 48.5%;\n    height: 100%;\n}\n\n.column--1-1 {\n    padding: 0 14px 20px 20px;\n    width: 99%;\n    height: 100%;\n}\n\n.column--header {\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.column--header_column {\n    -ms-flex-direction: column;\n        flex-direction: column;\n}\n\n.column--title {\n    font-size: 24px;\n    line-height: 1em;\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n}\n\n.column--title-regular {\n    font-weight: normal;\n    font-size: 24px;\n    line-height: 1em;\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/column.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/column.css
// module chunks = 0